module.exports = __webpack_public_path__ + "media/mypage/images/icons/s_icon_koyou-15fd1e2df1c53c96116d56d04dbac559.png";